import React, { forwardRef, useEffect, useState } from 'react';

const TapNavTabs = forwardRef((props, ref) => {


    useEffect(() => {

        onChangeTab(props.activetab || 0);

    }, []);

    const [activetab, setActivetab]         =   useState(null);
    let tabs                                =   props.tabs || [];

    const tabReinitialize                   =   props.tabReinitialize || "Y";


    const onChangeTab                       =   (index) => {
        setActivetab(index);
        if(props.setTabValue) {
            props.setTabValue(index);
        }
    } 
    
    return <>
        <ul className="nav nav-tabs bg-white">
            {tabs.map((t, i) => {
                return <li className='nav-item'>
                    <button
                        className={['nav-link', activetab == i && 'active'].join(" ")}
                        type="button"
                        onClick={() => onChangeTab(i)}
                    >{t.name && t.name} </button>
                </li>
            })}
        </ul>
        <div className={props.noHeaderClass ? "" : "tab_content_header mt-0 pt-2 pb-4"}>
            {tabReinitialize == 'Y' && activetab >= 0 && tabs.length > 0 && tabs[activetab] && tabs[activetab].jsx}
            {tabReinitialize == 'N' && tabs.length > 0 &&  tabs.map((t, i) => {
                return <div className={[activetab == i ? 'show' : 'hide'].join(" ")}>
                    {t.jsx}
                </div>
            })}
        </div> 
    </>

});

export default TapNavTabs;